module.exports = __webpack_public_path__ + "img/LoonityLogoWhiteLarge.aff21a56.png";